import React, { useState } from 'react';
import { ScrollSync, ScrollSyncPane } from 'react-scroll-sync';
import {
    StyledHeading,
    StyledArrow,
    StyledDataWrapper,
    StyledHeader,
    StyledHeaderElement,
} from '../../../styles/sharedStyles';
import { StyledHeadingCheckbox } from '../../atoms/SettlementsDoneElement/StyledHeadingCheckbox';
import { StyledText } from '../../atoms/Text/StyledText';
import { StyledDeleteCheckbox } from '../../atoms/UserPanelAddRole/StyledDeleteCheckbox';
import { StyledIsOpenWrapper } from '../../atoms/UserPanelAddRole/StyledIsOpenWrapper';
import { StyledSummaryEditElement } from '../../atoms/SummaryEditElement/StyledSummaryEditElement';
import { StyledDataWrapper as StyledDataInnerWrapper } from '../../atoms/UserPanelAddRole/StyledDataWrapper';
import { StyledPreferencesElement } from './UserPanelPreferences.styles';
import { getString } from '../../../strings';
import { cebulaCompare } from '../../../logic/arrays';
import useScrollBar from '../../../logic/hooks/useScrollBar';

const PreferencesElementForTrainers = ({ preferenceType, preferences, trigger }) => {
    const [isOpen, setIsOpen] = useState(false);
    const { scrollElement, isScrollBar } = useScrollBar(false, true);

    const handleOpen = () => {
        trigger();
        setIsOpen(!isOpen);
    };

    const sortedPreferences = Object.values(preferences || {}).sort((a, b) => {
        const value = a.value - b.value;
        if (value) return value;
        const lastname = cebulaCompare(a.student.lastname, b.student.lastname);
        if (lastname) return lastname;
        const firstname = cebulaCompare(a.student.firstname, b.student.firstname);
        if (firstname) return firstname;
        return 0;
    });

    return (
        <StyledPreferencesElement
            isopen={isOpen}
            hasdeclaredbordercolor={preferenceType === 'forbidden'}
        >
            <StyledHeading onClick={handleOpen}>
                <StyledText
                    hasdeclaredfontsize="22px"
                    hasdeclaredfontweight="700"
                    hasdeclaredtextalign="center"
                    hasdeclaredtexttransform="uppercase"
                    hasdeclaredfontcolor={preferenceType === 'forbidden' ? '#ee745c' : '#6786BE'}
                    hasdeclaredpadding="0 0 0 50px"
                >
                    {getString(`user_panel_preferences_${preferenceType}`)}
                </StyledText>
                <StyledHeadingCheckbox hasdeclaredbgcolor={preferenceType === 'forbidden'}>
                    <StyledArrow isopen={isOpen} />
                </StyledHeadingCheckbox>
            </StyledHeading>

            {isOpen && (
                <StyledDataWrapper>
                    <ScrollSync>
                        <>
                            <StyledIsOpenWrapper>
                                <ScrollSyncPane>
                                    <StyledHeader $isscrollbar={isScrollBar} ref={scrollElement}>
                                        <div>
                                            <StyledHeaderElement $hasWidth="50%">
                                                <StyledText
                                                    hasdeclaredfontsize="16px"
                                                    hasdeclaredfontweight="700"
                                                    hasdeclaredtextalign="center"
                                                    hasdeclaredlineheight="1.4em"
                                                >
                                                    {getString('user_panel_preferences_name')}
                                                </StyledText>
                                            </StyledHeaderElement>
                                            <StyledHeaderElement $hasWidth="50%">
                                                <StyledText
                                                    hasdeclaredfontsize="16px"
                                                    hasdeclaredfontweight="700"
                                                    hasdeclaredtextalign="center"
                                                    hasdeclaredlineheight="1.4em"
                                                >
                                                    {getString('user_panel_preferences_trainer')}
                                                </StyledText>
                                            </StyledHeaderElement>
                                        </div>
                                    </StyledHeader>
                                </ScrollSyncPane>
                                <StyledDeleteCheckbox isbgcolor />
                            </StyledIsOpenWrapper>

                            <div
                                style={{
                                    marginTop: '5px',
                                    display: 'flex',
                                    flexDirection: 'column',
                                    gap: '5px',
                                }}
                            >
                                {sortedPreferences.length ? (
                                    sortedPreferences.map((preference) => {
                                        return (
                                            <StyledSummaryEditElement
                                                key={preference.student.id}
                                                $minusWidth={50}
                                            >
                                                <ScrollSyncPane>
                                                    <div>
                                                        <StyledDataInnerWrapper>
                                                            <StyledHeaderElement $hasWidth="50%">
                                                                <StyledText
                                                                    hasdeclaredfontsize="16px"
                                                                    hasdeclaredfontweight="600"
                                                                    hasdeclaredtextalign="center"
                                                                    hasdeclaredlineheight="1.4em"
                                                                >
                                                                    {preference.student.name}
                                                                </StyledText>
                                                            </StyledHeaderElement>
                                                            <StyledHeaderElement $hasWidth="50%">
                                                                <StyledText
                                                                    hasdeclaredfontsize="16px"
                                                                    hasdeclaredfontweight="600"
                                                                    hasdeclaredtextalign="center"
                                                                    hasdeclaredlineheight="1.4em"
                                                                >
                                                                    {preference.trainer?.name ||
                                                                        '-'}
                                                                </StyledText>
                                                            </StyledHeaderElement>
                                                        </StyledDataInnerWrapper>
                                                    </div>
                                                </ScrollSyncPane>
                                            </StyledSummaryEditElement>
                                        );
                                    })
                                ) : (
                                    <StyledText
                                        hasdeclaredfontsize="16px"
                                        hasdeclaredfontweight="700"
                                        hasdeclaredtextalign="center"
                                        hasdeclaredlineheight="1.4em"
                                    >
                                        {getString('user_panel_preferences_no_preferences')}
                                    </StyledText>
                                )}
                            </div>
                        </>
                    </ScrollSync>
                </StyledDataWrapper>
            )}
        </StyledPreferencesElement>
    );
};

export default PreferencesElementForTrainers;
